// services/statistic-data/response/ReservationStatisticResponse.ts

import { z } from "zod";

// Skema untuk satu item dalam array 'data'
const ReservationStatisticItemSchema = z.object({
    name: z.string(),
    color: z.string(),
    total: z.number(),
});

// Skema untuk keseluruhan respons API
const ReservationStatisticResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(ReservationStatisticItemSchema),
});

// Ekspor tipe data yang di-infer dari skema
type ReservationStatisticResponse = z.infer<typeof ReservationStatisticResponseSchema>;
type ReservationStatisticData = z.infer<typeof ReservationStatisticResponseSchema>['data'];

export { ReservationStatisticResponseSchema };
export type { ReservationStatisticResponse, ReservationStatisticData };